import React from "react";
import { MashkorSmallIcon } from "../../assets/icons";
import { useStyles } from "./styles";

export function MashkorIcon() {
  const classes = useStyles();
  return <img src={MashkorSmallIcon} className={classes.root} alt=''/>;
}
